
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_vrgzu_1alcn_3",
  "recovery": "awsui_recovery_vrgzu_1alcn_14"
};
  